module.exports = __webpack_public_path__ + "media/images/press_kit/shoretime_light/email/top-8e0fdaac896dbe0349a711d057b7411d.png";